<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-success p-mr-2"
            (click)="eventCancel()"  *ngIf="this.showBackButton"></button>
        <button pButton pRipple label="{{lbl_new_record}}" icon="pi pi-plus" class="p-button-success p-mr-2"
            (click)="openNew()"></button>
        
    </ng-template>
</p-toolbar>

<div class="card">
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_item}}:</span>
                    <span class="p-text-bold">{{itemId}} - {{item!=null && item.descri!=null?item.descri:""}} -
                        {{item!=null && item.descri!=null?item.sellUM:""}}</span>
                </div>
                



            </p-panel>
        </div>



    </div>

    <p-table #dt [value]="lstItemsAlbum" [globalFilterFields]="['name']" [rowHover]="true" dataKey="id"
        styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{lbl_collections}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>

                <th style="width:5rem" pSortableColumn="sequence">{{lbl_id}}<p-sortIcon field="sequence">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="name">{{lbl_name}}<p-sortIcon field="name">
                    </p-sortIcon>
                </th>
                <th style="width:4rem" >{{lbl_edit}}</th>
                <th>{{lbl_select}}</th>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-value>
            <tr>
                <td>{{value.id.albumId}}</td>
                <td>{{value.name}}</td>
                <td  >
                    <button type="button" pButton pRipple icon="pi pi-pencil" 
                        class="p-button-rounded p-button-success p-mr-2" (click)="edit(value)"></button>
                </td>
                <td>
                    <button type="button"  pButton pRipple icon="pi pi-search" (click)="selectRecord(value.id.albumId)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{lbl_total}} {{lstItemsAlbum ? lstItemsAlbum.length : 0 }} .
            </div>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="itemDialog" [style]="{width: '750px'}" header="itemTrack" [modal]="true"
        styleClass="p-fluid">
        <ng-template pTemplate="content">

            <div class="p-field">
                <label for="albumId">{{lbl_id}}: *</label>
                <p-inputNumber id="albumId" [(ngModel)]="albumId" mode="decimal" [max]="99" [disabled]="true"></p-inputNumber>
                
                <label for="name">{{lbl_name}}: *</label>
                <input type="text" pInputText id="name" [(ngModel)]="name" required autofocus maxlength="60"/>
                <small class="p-error" *ngIf="!name">{{lbl_name}} requerido.</small>               

            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-times" class="p-button-danger p-button-text"
                (click)="hideDialog()"></button>
            <button pButton pRipple label="{{lbl_delete_record}}" icon="pi pi-times" class="p-button-delete p-button-text"
                (click)="removeSelected()"></button>
            <button pButton pRipple label="{{lbl_save}}" icon="pi pi-check" class="p-button-success p-button-text"
                (click)="createUpdate()"></button>
        </ng-template>
    </p-dialog>

</div>
